import { RootState, useAppSelector } from '../state/rootReducer'
import { matchPlanMeta } from '../utils/plans'
import { PlanDataAndMeta } from '../utils/plans.types'

interface UseGroupPlansResult {
  isLoading: boolean
  list: PlanDataAndMeta[]
}

export const useGroupPlans = (slugs: string[]): UseGroupPlansResult => {
  const { plans, loading: isLoading } = useAppSelector(
    (state: RootState) => state.groupPlans
  )

  if (isLoading || plans.length === 0) {
    return {
      isLoading: true,
      list: [],
    }
  }

  // { priceData, planMeta }
  const list = slugs
    .map((slug) => matchPlanMeta(plans, slug))
    .filter((item) => item !== null)

  return {
    isLoading: false,
    list,
  }
}
